// extracted by mini-css-extract-plugin
export default {"table":"AdminRoleManager_table__bSRwN"};